import * as types from './index';

export const timesheetListAction =(data) =>{ 
    return {
        type: types.TIMESHEET_LIST,
        data
    }
}

export const timesheetDetailsAction =(data) =>{ 
    return {
        type: types.TIMESHEET_DETAILS,
        data
    }
}

export const timesheetUpdateAction =(data) =>{ 
    return {
        type: types.TIMESHEET_UPDATE,
        data
    }
}

export const timesheetFilterEventsListAction =(data) =>{ 
    return {
        type: types.TIMESHEET_FILTER_EVENTS,
        data
    }
}

export const timesheetFilterLocationsListAction =(data) =>{ 
    return {
        type: types.TIMESHEET_FILTER_LOCATION,
        data
    }
}
export const timesheetFilterCrewsListAction =(data) =>{ 
    return {
        type: types.TIMESHEET_FILTER_CREW,
        data
    }
}
export const timesheetFilterSkillsListAction =(data) =>{ 
    return {
        type: types.TIMESHEET_FILTER_SKILL,
        data
    }
}
export const timesheetFilterDepartmentsListAction =(data) =>{ 
    return {
        type: types.TIMESHEET_FILTER_DEPARTMENT,
        data
    }
}

export const timesheetShiftListAction =(data) =>{ 
    return {
        type: types.TIMESHEET_SHIFT_LIST,
        data
    }
}

export const timesheetCSVDownloadAction =(data) =>{ 
    return {
        type: types.TIMESHEET_CSV_DOWNLOAD,
        data
    }
}

export const timesheetSummaryCSVDownloadAction =(data) =>{ 
    return {
        type: types.TIMESHEET_SUMMARY_CSV_DOWNLOAD,
        data
    }
}

export const setActionNeeded = (data) => {  
    return {
        type: types.SET_ACTION_NEEEDED,
        data
    }
}
